import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
const ChartComponent = () => {
  const allData = [
    
    { date: "2025-01-01", value: 9000 },
    { date: "2025-01-02", value: 9200 },
    { date: "2025-01-03", value: 9200 },
    { date: "2025-01-04", value: 9400 },
    { date: "2025-01-05", value: 9250 },
    { date: "2025-01-06", value: 9350 },
    { date: "2025-01-07", value: 9850 },
    { date: "2025-01-08", value: 9200 },
    { date: "2025-01-09", value: 9400 },
    { date: "2025-01-10", value: 9200 },
    { date: "2025-01-11", value: 9200 },
    { date: "2025-01-12", value: 9800 },
    { date: "2025-01-13", value: 9200 },
    { date: "2025-01-14", value: 9200 },
    { date: "2025-01-15", value: 9000 },
    { date: "2025-01-16", value: 9200 },
    { date: "2025-01-17", value: 9500 },
    { date: "2024-12-01", value: 9000 },
    { date: "2024-12-02", value: 9200 },
    { date: "2024-12-03", value: 9200 },
    { date: "2024-12-04", value: 9400 },
    { date: "2024-12-05", value: 9250 },
    { date: "2024-12-06", value: 9350 },
    { date: "2024-12-07", value: 9850 },
    { date: "2024-12-08", value: 9200 },
    { date: "2024-12-09", value: 9400 },
    { date: "2024-12-10", value: 9200 },
    { date: "2024-12-11", value: 9200 },
    { date: "2024-12-12", value: 9800 },
    { date: "2024-12-13", value: 9200 },
    { date: "2024-12-14", value: 9200 },
    { date: "2024-12-15", value: 9000 },
    { date: "2024-12-16", value: 9200 },
    { date: "2024-12-17", value: 9500 },
    { date: "2024-12-18", value: 9200 },
    { date: "2024-12-19", value: 9000 },
    { date: "2024-12-20", value: 9800 },
    { date: "2024-12-21", value: 9000 },
    { date: "2024-12-22", value: 9500 },
    { date: "2024-12-23", value: 9000 },
    { date: "2024-12-24", value: 9500 },
    { date: "2024-12-25", value: 9200 },
    { date: "2024-12-26", value: 9500 },
    { date: "2024-12-27", value: 9600 },
    { date: "2024-12-28", value: 9600 },
    { date: "2024-12-29", value: 8600 },
    { date: "2024-12-30", value: 7600 },
    { date: "2024-11-01", value: 7000 },
    { date: "2024-11-02", value: 6200 },
    { date: "2024-11-03", value: 7200 },
    { date: "2024-11-04", value: 7400 },
    { date: "2024-11-05", value: 7250 },
    { date: "2024-11-06", value: 7350 },
    { date: "2024-11-07", value: 6850 },
    { date: "2024-11-08", value: 7200 },
    { date: "2024-11-09", value: 7400 },
    { date: "2024-11-10", value: 8200 },
    { date: "2024-11-11", value: 7200 },
    { date: "2024-11-12", value: 6800 },
    { date: "2024-11-13", value: 7200 },
    { date: "2024-11-14", value: 6200 },
    { date: "2024-11-15", value: 7000 },
    { date: "2024-11-16", value: 7200 },
    { date: "2024-11-17", value: 7500 },
    { date: "2024-11-18", value: 8200 },
    { date: "2024-11-19", value: 7000 },
    { date: "2024-11-20", value: 6800 },
    { date: "2024-11-21", value: 7000 },
    { date: "2024-11-22", value: 6500 },
    { date: "2024-11-23", value: 8000 },
    { date: "2024-11-24", value: 7500 },
    { date: "2024-11-25", value: 8200 },
    { date: "2024-11-26", value: 5500 },
    { date: "2024-11-27", value: 5600 },
    { date: "2024-11-28", value: 7600 },
    { date: "2024-11-29", value: 7600 },
    { date: "2024-11-30", value: 7600 },
    { date: "2024-10-01", value: 7000 },
    { date: "2024-10-02", value: 6200 },
    { date: "2024-10-03", value: 7200 },
    { date: "2024-10-04", value: 7400 },
    { date: "2024-10-05", value: 7250 },
    { date: "2024-10-06", value: 7350 },
    { date: "2024-10-07", value: 6850 },
    { date: "2024-10-08", value: 7200 },
    { date: "2024-10-09", value: 7400 },
    { date: "2024-10-10", value: 8200 },
    { date: "2024-10-11", value: 7200 },
    { date: "2024-10-12", value: 6800 },
    { date: "2024-10-13", value: 7200 },
    { date: "2024-10-14", value: 6200 },
    { date: "2024-10-15", value: 7000 },
    { date: "2024-10-16", value: 7200 },
    { date: "2024-10-17", value: 7500 },
    { date: "2024-10-18", value: 8200 },
    { date: "2024-10-19", value: 7000 },
    { date: "2024-10-20", value: 6800 },
    { date: "2024-10-21", value: 7000 },
    { date: "2024-10-22", value: 6500 },
    { date: "2024-10-23", value: 8000 },
    { date: "2024-10-24", value: 7500 },
    { date: "2024-10-25", value: 8200 },
    { date: "2024-10-26", value: 5500 },
    { date: "2024-10-27", value: 5600 },
    { date: "2024-10-28", value: 7600 },
    { date: "2024-10-29", value: 7600 },
    { date: "2024-10-30", value: 7600 },
    { date: "2024-09-01", value: 7000 },
    { date: "2024-09-02", value: 6200 },
    { date: "2024-09-03", value: 7200 },
    { date: "2024-09-04", value: 7400 },
    { date: "2024-09-05", value: 7250 },
    { date: "2024-09-06", value: 7350 },
    { date: "2024-09-07", value: 6850 },
    { date: "2024-09-08", value: 7200 },
    { date: "2024-09-09", value: 7400 },
    { date: "2024-09-10", value: 8200 },
    { date: "2024-09-11", value: 7200 },
    { date: "2024-09-12", value: 6800 },
    { date: "2024-09-13", value: 7200 },
    { date: "2024-09-14", value: 6200 },
    { date: "2024-09-15", value: 7000 },
    { date: "2024-09-16", value: 7200 },
    { date: "2024-09-17", value: 7500 },
    { date: "2024-09-18", value: 8200 },
    { date: "2024-09-19", value: 7000 },
    { date: "2024-09-20", value: 6800 },
    { date: "2024-09-21", value: 7000 },
    { date: "2024-09-22", value: 6500 },
    { date: "2024-09-23", value: 8000 },
    { date: "2024-09-24", value: 7500 },
    { date: "2024-09-25", value: 8200 },
    { date: "2024-09-26", value: 5500 },
    { date: "2024-09-27", value: 5600 },
    { date: "2024-09-28", value: 7600 },
    { date: "2024-09-29", value: 7600 },
    { date: "2024-09-30", value: 7600 },
    { date: "2024-08-01", value: 7000 },
    { date: "2024-08-02", value: 6200 },
    { date: "2024-08-03", value: 7200 },
    { date: "2024-08-04", value: 7400 },
    { date: "2024-08-05", value: 7250 },
    { date: "2024-08-06", value: 7350 },
    { date: "2024-08-07", value: 6850 },
    { date: "2024-08-08", value: 7200 },
    { date: "2024-08-09", value: 7400 },
    { date: "2024-08-10", value: 8200 },
    { date: "2024-08-11", value: 7200 },
    { date: "2024-08-12", value: 6800 },
    { date: "2024-08-13", value: 7200 },
    { date: "2024-08-14", value: 6200 },
    { date: "2024-08-15", value: 7000 },
    { date: "2024-08-16", value: 7200 },
    { date: "2024-08-17", value: 7500 },
    { date: "2024-08-18", value: 8200 },
    { date: "2024-08-19", value: 7000 },
    { date: "2024-08-20", value: 6800 },
    { date: "2024-08-21", value: 7000 },
    { date: "2024-08-22", value: 6500 },
    { date: "2024-08-23", value: 8000 },
    { date: "2024-08-24", value: 7500 },
    { date: "2024-08-25", value: 8200 },
    { date: "2024-08-26", value: 5500 },
    { date: "2024-08-27", value: 5600 },
    { date: "2024-08-28", value: 7600 },
    { date: "2024-08-29", value: 9600 },
    { date: "2024-08-30", value: 9600 },
    { date: "2024-07-01", value: 9000 },
    { date: "2024-07-02", value: 9200 },
    { date: "2024-07-03", value: 9200 },
    { date: "2024-07-04", value: 9400 },
    { date: "2024-07-05", value: 9250 },
    { date: "2024-07-06", value: 9350 },
    { date: "2024-07-07", value: 9850 },
    { date: "2024-07-08", value: 9200 },
    { date: "2024-07-09", value: 9400 },
    { date: "2024-07-10", value: 9200 },
    { date: "2024-07-11", value: 9200 },
    { date: "2024-07-12", value: 9800 },
    { date: "2024-07-13", value: 9200 },
    { date: "2024-07-14", value: 9200 },
    { date: "2024-07-15", value: 9000 },
    { date: "2024-07-16", value: 9200 },
    { date: "2024-07-17", value: 9500 },
    { date: "2024-07-18", value: 9200 },
    { date: "2024-07-19", value: 9000 },
    { date: "2024-07-20", value: 9800 },
    { date: "2024-07-21", value: 9000 },
    { date: "2024-07-22", value: 9500 },
    { date: "2024-07-23", value: 9000 },
    { date: "2024-07-24", value: 9500 },
    { date: "2024-07-25", value: 9200 },
    { date: "2024-07-26", value: 9500 },
    { date: "2024-07-27", value: 9600 },
    { date: "2024-07-28", value: 9600 },
    { date: "2024-07-29", value: 9600 },
    { date: "2024-07-30", value: 9600 },
  ];
  const [timeFrame, setTimeFrame] = useState("30days");
  
  const filteredData = (() => {
    const today = new Date();
    if (timeFrame === "7days") {
      const lastWeekDate = new Date(today);
      lastWeekDate.setDate(today.getDate() - 7);
      return allData.filter((item) => new Date(item.date) >= lastWeekDate);
    } else if (timeFrame === "30days") {
      const last30DaysDate = new Date(today);
      last30DaysDate.setDate(today.getDate() - 30);
  
      return allData
        .filter((item) => new Date(item.date) >= last30DaysDate)
        .sort((a, b) => new Date(a.date) - new Date(b.date));
    } else if (timeFrame === "6months") {
      const last6MonthsDate = new Date(today);
      last6MonthsDate.setMonth(today.getMonth() - 6);
  
      const uniqueMonths = new Map(); 
      const result = allData
        .filter((item) => new Date(item.date) >= last6MonthsDate)
        .filter((item) => {
          const monthKey = new Date(item.date).toISOString().slice(0, 7); 
          if (uniqueMonths.has(monthKey)) return false;
          uniqueMonths.set(monthKey, true);
          return true;
        });
  
     
      return result.sort((a, b) => new Date(a.date) - new Date(b.date));
    }
    return allData;
  })();
  
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    if (timeFrame === "30days") {
     
      const options = { day: "2-digit", month: "short" };
      return date.toLocaleDateString("en-GB", options);
    } else if (timeFrame === "6months") {
     
      const options = { month: "long" };
      return date.toLocaleDateString("en-GB", options);
    }
    return dateStr;
  };

  const chartData = {
    labels: filteredData.map((data) => formatDate(data.date)),
    datasets: [
      {
        label: "Gold Price",
        data: filteredData.map((data) => data.value),
        borderColor: "#FFC000",
        backgroundColor: "#FFC000",
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Gold Price Trend",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
       
        },
        ticks: {
          maxRotation: 90, 
          minRotation: 90,
        },
      },
      y: {
        title: {
          display: true,
          text: "Price",
        },
        suggestedMin: 5000,
        suggestedMax: 10000,
      },
    },
  };
  return (
    <div style={{ width: "100%", height: "100%"}}>
      <div style={{ marginBottom: "20px", textAlign: "center" }}>
        <button
          onClick={() => setTimeFrame("7days")}
          style={{
            margin: "0 10px",
            padding: "10px 20px",
            background: timeFrame === "7days" ? "#ffd700" : "#f0f0f0",
            border: "1px solid #ccc",
            cursor: "pointer",
            color:'0000',
          }}
        >
          Last Week
        </button>
        <button
          onClick={() => setTimeFrame("30days")}
          style={{
            margin: "0 10px",
            padding: "10px 20px",
            background: timeFrame === "30days" ? "#ffd700" : "#f0f0f0",
            border: "1px solid #ccc",
            cursor: "pointer",
          }}
        >
          Last 30 Days
        </button>
        <button
          onClick={() => setTimeFrame("6months")}
          style={{
            margin: "0 10px",
            padding: "10px 20px",
            background: timeFrame === "6months" ? "#ffd700" : "#f0f0f0",
            border: "1px solid #ccc",
            cursor: "pointer",
          }}
        >
          Last 6 Months
        </button>
      </div>
      <Line data={chartData} options={chartOptions}  />
    </div>
  );
};

export default ChartComponent;